import { createFileRoute } from "@tanstack/react-router";
import { DashboardSettingsPage } from "@/pages/dashboard/SettingsPage";

export const Route = createFileRoute("/dashboard/settings")({ component: DashboardSettingsPage });
